(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Module_trDialogController', Module_trDialogController);

    Module_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Module_tr', 'Module'];

    function Module_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Module_tr, Module) {
        var vm = this;

        vm.module_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modules = Module.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.module_tr.id !== null) {
                Module_tr.update(vm.module_tr, onSaveSuccess, onSaveError);
            } else {
                Module_tr.save(vm.module_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:module_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
